import { render, staticRenderFns } from "./PackageDescriptionItems.vue?vue&type=template&id=b425c692&"
import script from "./PackageDescriptionItems.vue?vue&type=script&lang=ts&"
export * from "./PackageDescriptionItems.vue?vue&type=script&lang=ts&"
import style0 from "./PackageDescriptionItems.vue?vue&type=style&index=0&id=b425c692&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports